import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.brand}>
          <div className={styles.logo}>🌿 UrbanLife<span>.Works</span></div>
          <p>Connecting urban communities with local farmers, artisans, and service providers.</p>
          <div className={styles.newsletter}>
            <input type="email" placeholder="Your email" className={styles.emailInput} />
            <button className="btn btn-primary">Subscribe</button>
          </div>
        </div>

        <div className={styles.col}>
          <h4>Ecosystem</h4>
          <Link to="/marketplace">Marketplace</Link>
          <Link to="/sanctuary">Sanctuaries</Link>
          <Link to="/community">Community Map</Link>
          <Link to="/solutions">Shared Resources</Link>
        </div>

        <div className={styles.col}>
          <h4>Company</h4>
          <Link to="/about">About Us</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className={styles.col}>
          <h4>Legal</h4>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/cookies">Cookie Settings</Link>
        </div>
      </div>

      <div className={`container ${styles.bottom}`}>
        <p>© {new Date().getFullYear()} Vizneo Co., Ltd. All rights reserved.</p>
        <div className={styles.social}>
          <a href="https://instagram.com/urbanlifeworks" target="_blank" rel="noopener">Instagram</a>
          <a href="https://linkedin.com/company/urbanlifeworks" target="_blank" rel="noopener">LinkedIn</a>
          <a href="https://twitter.com/urbanlifeworks" target="_blank" rel="noopener">Twitter</a>
        </div>
      </div>
    </footer>
  );
}
